export const FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME = 'actionType'

export const FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_API_FIELD_NAME = 'command'
